import React, { Component } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { Menu, X, Search, Settings, User, HelpCircle, Lock, LogOut } from 'react-feather';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { showRightSidebar } from 'service/appconfiguration/action';
import * as FeatherIcon from 'react-feather';
import './index.css';
import { getUserDetails } from 'service/users/action';
import ProfileDropdown from '../ProfileDropdown';
import LanguageDropdown from '../LanguageDropdown';
import NotificationDropdown from '../NotificationDropdown';
import SettingsDropdown from '../SettingsDropdown';
import logo from 'images/logoNoBackground.png';
import profilePic from 'images/users/avatar-7.jpg';
import _isEmpty from 'lodash/isEmpty';
import LogoutModal from '../LogoutModal';

const UserInfo = () => {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(getUserDetails());
    }, []);
    return null;
};
const UserProfile = ({ props }) => {
    const dispatch = useDispatch();
    return (
        <React.Fragment>
            <div
                className={
                    parseInt(localStorage.getItem('theme'))
                        ? 'media user-profile top-bar-dark d-flex justify-content-center'
                        : 'media user-profile top-bar-light d-flex justify-content-center'
                }
            >
                <div>
                    <h6 className="pro-user-name d-flex justify-content-between">{props.user.displayname}</h6>
                    {/* <span className="pro-user-desc">Administrator</span> */}
                </div>

                {/* <UncontrolledDropdown className="align-self-center profile-dropdown-menu">
                <DropdownToggle
                    data-toggle="dropdown"
                    tag="button"
                    className="btn btn-link p-0 dropdown-toggle me-0">
                    <FeatherIcon.ChevronDown />
                </DropdownToggle>
                <DropdownMenu right className="topbar-dropdown-menu profile-dropdown-items">
                    <Link to="/" className="dropdown-item notify-item">
                        <FeatherIcon.User className="icon-dual icon-xs me-2" />
                        <span>My Account</span>
                    </Link>
                    <Link to="/" className="dropdown-item notify-item">
                        <FeatherIcon.Settings className="icon-dual icon-xs me-2" />
                        <span>Settings</span>
                    </Link>
                    <Link to="/" className="dropdown-item notify-item">
                        <FeatherIcon.HelpCircle className="icon-dual icon-xs me-2" />
                        <span>Support</span>
                    </Link>
                    <Link to="/" className="dropdown-item notify-item">
                        <FeatherIcon.Lock className="icon-dual icon-xs me-2" />
                        <span>Lock Screen</span>
                    </Link>
                    <DropdownItem divider />
                    <Link to="/account/login" onClick={() => dispatch(logout())} className="dropdown-item notify-item">
                        <FeatherIcon.LogOut className="icon-dual icon-xs me-2" />
                        <span>Logout</span>
                    </Link>
                </DropdownMenu>
            </UncontrolledDropdown> */}
            </div>
        </React.Fragment>
    );
};

const Notifications = [
    {
        id: 1,
        text: 'New user registered',
        subText: '1 min ago',
        icon: 'uil uil-user-plus',
        bgColor: 'primary',
    },
    {
        id: 2,
        text: 'Karen Robinson',
        subText: 'Wow ! this admin looks good and awesome design',
        icon: 'uil uil-comment-message',
        bgColor: 'success',
    },
    {
        id: 3,
        text: 'Cristina Pride',
        subText: 'Hi, How are you? What about our next meeting',
        icon: 'uil uil-comment-message',
        bgColor: 'danger',
    },
    {
        id: 4,
        text: 'New user registered',
        subText: '1 day ago',
        icon: 'uil uil-user-plus',
        bgColor: 'info',
    },
];

const ProfileMenus = [
    {
        label: 'My Account',
        icon: User,
        redirectTo: '/',
    },
    {
        label: 'Settings',
        icon: Settings,
        redirectTo: '/',
    },
    {
        label: 'Support',
        icon: HelpCircle,
        redirectTo: '/',
    },
    {
        label: 'Lock Screen',
        icon: Lock,
        redirectTo: '/',
    },
    {
        label: 'Logout',
        icon: LogOut,
        redirectTo: '/account/login',
        hasDivider: true,
    },
];

class Topbar extends Component {
    constructor(props) {
        super(props);
        this.handleRightSideBar = this.handleRightSideBar.bind(this);
        this.state = {
            language: 0,
            theme: parseInt(localStorage.getItem('theme')),
            isLogoutMdalOpen: false,
        };
    }
    /**
     * Toggles the right sidebar
     */
    handleRightSideBar = () => {
        this.props.showRightSidebar();
    };
    handleLangChange = (event) => {
        if (event.target.checked == true) {
            this.setState({ theme: 1 });
            localStorage.setItem('theme', 1);
            location.reload();
        } else {
            this.setState({ theme: 0 });
            localStorage.setItem('theme', 0);
            location.reload();
        }
    };
    render() {
        return (
            <React.Fragment>
                <UserInfo />
                <div className="navbar navbar-expand flex-column flex-md-row navbar-custom">
                    <Container fluid>
                        {/* logo */}
                        <Link to="/" className="navbar-brand me-0 me-md-2 logo topbar-text-width">
                            <span className="logo-lg">
                                <img src={logo} alt="" height="24" className="forTheImage ms-1" />
                                <span className="topbar-text-width">
                                    <span className="d-inline h5 ms-3 text-logo1">BlocRecon</span>
                                </span>
                            </span>
                        </Link>
                        <ul className="navbar-nav flex-row   list-unstyled topnav-menu mb-0" style={{ marginLeft: '50px' }}>
                            {/* <div className="app-search">
                                <form>
                                    <div className="input-group">
                                        <input type="text" className="form-control" placeholder="Search..." />
                                        <Search />
                                    </div>
                                </form>
                            </div>
                            <LanguageDropdown tag="li" />
                            <NotificationDropdown notifications={Notifications} /> */}
                        </ul>
                        {/* menu*/}
                        <ul className="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
                            <li className="">
                                <button className="button-menu-mobile open-left disable-btn" onClick={this.props.openLeftMenuCallBack}>
                                    <Menu className="menu-icon" />
                                    <X className="close-icon" />
                                </button>
                            </li>
                        </ul>
                        <ul className="navbar-nav flex-row ms-auto d-flex list-unstyled topnav-menu float-end mb-0">
                            <SettingsDropdown />
                            {/* <li className="d-none d-sm-block"> */}
                            {/* <div className="app-search">
                                    <form>
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search..." />
                                            <Search />
                                        </div>
                                    </form>
                                </div> */}
                            {/* </li> */}
                            <div>
                                <button title="Logout">
                                    <LogOut
                                        style={{ color: '#4BB3BC', margin: '17px 0px 0px 0px', cursor: 'pointer' }}
                                        className="icon-md me-2"
                                        onClick={() => this.setState({ isLogoutMdalOpen: true })}
                                    />
                                </button>
                            </div>
                            <UserProfile props={this.props} />
                            <ProfileDropdown
                                profilePic={profilePic}
                                menuItems={ProfileMenus}
                                username={'Recon N'}
                                description="Administrator"
                            />
                        </ul>
                    </Container>
                    <LogoutModal isModalOpen={this.state.isLogoutMdalOpen} updateModal={() => this.setState({ isLogoutMdalOpen: false })} />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        projectStatus: state.projectReducer,
        user: state.usersReducer.userDetails,
    };
};

export default connect(mapStateToProps, { showRightSidebar })(Topbar);
